import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import { BLUE } from '../styles'

const DEFAULT_FONT_SIZE = 14
const DEFAULT_PADDING = '5px'

const width = css`
  width: ${props => props.width}px;
`
const height = css`
  height: ${props => props.height}px;
`
const BlueButtonContainer = styled.button`
  display: inline-block;
  background: ${BLUE};
  border: 1px solid ${BLUE};
  color: white;
  border-radius: 2px;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  padding: ${props => props.padding};
  ${props => props.width ? width : null}
  ${props => props.height ? height : null}

  &:hover {
    opacity: 1;
    box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.25), inset 0px 1px 2px 0px transparent;
  }
`

const BlueButtonLabel = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  text-align: center;
  font-size: ${props => props.fontSize}px;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
`

const BlueButton = (props) => {
  const onClick = props.onClick
  const text = props.text

  const fontSize = props.fontSize || DEFAULT_FONT_SIZE
  const padding = props.padding || DEFAULT_PADDING
  const width = props.width
  const height = props.height

  return (
    <BlueButtonContainer
      width={width}
      height={height}
      padding={padding}
      onClick={onClick}
    >
      <BlueButtonLabel fontSize={fontSize}>{text}</BlueButtonLabel>
    </BlueButtonContainer>
  )
}

BlueButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  fontSize: PropTypes.number,
  padding: PropTypes.string,
}

export default BlueButton



// WEBPACK FOOTER //
// ./src/components/signin/BlueButton.js